import { PROPERTY } from "@src/pages/Dashboard/HomeDashboard/TotalSales/helper";
import { displayNotesProperties } from "./helper";

const useShowNote = (property: string | null, storeId: string | null) => {
  if (property === null || property === undefined) return false;

  return Boolean(
    (property === PROPERTY.RESTAURANTS_CATERING && storeId) ||
      displayNotesProperties.includes(property)
  );
};

export default useShowNote;
